export const RAW_MATERIALS = {
  HOME: 'campaign-home',
  IMPACT: 'campaign-impact',
  IMPACT_DETAIL: 'campaign-impact-detail',
  METAL: 'campaign-metal',
  METAL_DETAIL: 'campaign-metal-detail',
  VIDEO: 'campaign-video',
  TAKE_ACTIONS: 'campaign-take-action',
} as const
